module.exports = ".container {\n  background-color: red;\n  height: 100%;\n  width: 100%; }\n\n.iframe {\n  width: 100%;\n  height: calc(100vh - 3rem); }\n"